import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import moment from "moment";
import axios from "../../../axios";
import FilterNotFound from "../../../HwManagement/HomeWork/Filter_Box/FilterNotFound";
import { SubjectIcon } from "../../../SubjectIcon";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { shortenParagraph } from "../../../utils/Engagement";
import { Tooltip } from "@mui/material";

export default function CompletedSA({ setHomeMain, filter }) {
  const [completed, setCompleted] = useState({
    questionCompleted: false,
    homeworkId: null,
  });
  const navigate = useNavigate()
  const [completedCard, setCompletedCard] = useState([]);
  const currentUser = useSelector((state) => state.user.currentUser);
  const [isGettingData, setIsGettingData] = useState(true);
  const [noContentClick, setNoContentClick] = useState(false);

  const getCompletedSA = async () => {
    try {
      let response = await axios.get(
        `/selfAssess/filterByStudentId/${currentUser?.id}/completed?_page=${filter?.page}&_limit=${filter?.limit}&sortBy=${filter?.sortBy}` +
        `${filter?.date
          ? `&date=${moment(filter?.date).format("YYYY-MM-DD")}`
          : ``
        }` +
        `${filter?.time ? `&time=${filter?.time}` : ``}` +
        `${filter?.subjectId?.length !== 0
          ? `&subjectId=${filter?.subjectId}`
          : ``
        }`
      );

      response && setCompletedCard(response.data.data);
      setIsGettingData(false);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getCompletedSA();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter]);

  const timeHelper = (a) => {
    const dateObj = new Date(a);
    const day = dateObj.getUTCDate().toString().padStart(2, "0");
    const month = (dateObj.getUTCMonth() + 1).toString().padStart(2, "0");
    const year = dateObj.getUTCFullYear();
    const outputDateString = `${day}/${month}/${year}`;
    return outputDateString;
  };

  const handleQuestionfalse = () => {
    setCompleted({
      ...completed,
      questionCompleted: false,
    });
  };
  return (
    <div>
      {completedCard && completedCard.length > 0 ? (
        <div>
          <div className="d-flex gap-4 mt-3 flex-wrap">
            {completedCard?.map((item, index) => (
              <NavLink
                key={index}
                // className="summarySubBoxContainerHW summarySubBoxContainerSA"
                className="w-80 h-[21rem] d-flex flex-column py-2 px-3 text-start shadow-sm rounded-4 cursor-pointer card_style"
                style={{
                  borderTop: `2px solid #8D4B28`
                }}
                state={{ "selfAssessmentId": item?.id }}
                to={`/completedSelfAssessment`}
              >
                <div
                  className="d-flex SubsummarySubBoxContainer justify-content-between align-items-center"
                  style={{
                    borderTop: `10px solid #${item?.subject?.subject_color}`,
                    paddingBottom: "0",
                  }}
                >
                  <div>
                    <div className="subboxSubjectName">
                      {item?.subject?.name ?? " "}
                    </div>
                  </div>
                  <div>
                    <img
                      src={`${SubjectIcon?.find(
                        (i) => i.subjectName === item?.subject?.name
                      )?.icon
                        }`}
                      alt=""
                    />
                  </div>
                </div>
                <div
                  className="SubsummarySubBoxContainer"
                  style={{ paddingTop: "0" }}
                >
                  <div className="headingOfHW" title={item?.name}>
                    {item?.name}
                  </div>
                  <div>
                    <span className="deadline">Created</span> &nbsp;
                    <span className="deadlineDate">
                      {timeHelper(item?.created_at)}
                    </span>
                  </div>
                  <div>
                    <span className="deadline">Book : </span> &nbsp;
                    <span className="deadlineDate">
                      {/* {item?.book !== "Auto" ? item?.book?.name : item?.book} */}
                      <Tooltip
                        title={item?.book !== "Auto" ? item?.book?.name : item?.book}
                        arrow
                        placement="top"
                        enterDelay={200}
                        leaveDelay={100}
                      >
                        <span className="">
                          {item?.book !== "Auto" ? shortenParagraph(item?.book?.name, 30) : shortenParagraph(item?.book, 30)}
                        </span>
                      </Tooltip>
                    </span>
                  </div>
                  <div>
                    <span className="deadline">Chapter : </span> &nbsp;
                    <span className="deadlineDate">
                      {/* {item?.chapter !== "Auto" ? item?.chapter?.name : item?.chapter} */}
                      <Tooltip
                        title={item?.chapter !== "Auto" ? item?.chapter?.name : item?.chapter}
                        arrow
                        placement="top"
                        enterDelay={200}
                        leaveDelay={100}
                      >
                        <span className="">
                          {item?.chapter !== "Auto" ? shortenParagraph(item?.chapter?.name, 30) : shortenParagraph(item?.chapter, 30)}
                        </span>
                      </Tooltip>
                    </span>
                  </div>
                  <div>
                    <span className="deadline">Skill : </span> &nbsp;
                    <span className="deadlineDate">
                      {item?.knowledgeSkill !== "Auto" ? item?.knowledgeSkill?.name : item?.knowledgeSkill}
                    </span>
                  </div>
                  <div>
                    <span className="deadline">Difficulty : </span> &nbsp;
                    <span className="deadlineDate">
                      {item?.difficultyLevel !== "Auto" ? item?.difficultyLevel?.name : item?.difficultyLevel}
                    </span>
                  </div>
                  <div className=" float-end">
                    <span className="deadlineDate">
                      {item?.obtained_marks + "/" + item?.total_marks}
                    </span>
                  </div>
                </div>

                <div className="mt-2 d-flex justify-content-center w-100" >
                  <NavLink state={{ "selfAssessmentId": item?.id }} to={`/retestSelfAssessment`} className="btn" style={{ border: "1px solid orange", color: "red", fontSize: "12px" }}>Re-Test</NavLink>
                </div>

              </NavLink>
            ))}
          </div>
        </div>
      ) : isGettingData ? (
        <img className="ongoing_loader" src="/gif/LoaderDot.gif" alt="" />
      )
        : (<span >Self Assessment Not Found</span>
          // : noContentClick ? (
          //   <span>Homework Not Found</span>
          // ) : (
          //   <FilterNotFound setNoContentClick={setNoContentClick} />
        )}
    </div>
  );
}
